import { queryGetReport } from '../Queries';
import moment from 'moment-timezone';
import featureFlags from '../featureFlags';

const isEmpty = value => value === null || value === '' || value === undefined;

const convertToApiBody = (facilityId, filterValues) => {
  const data = {
    report: 'TransactionReport',
    format: 'csv',
    params: {
      facilityId,
    },
  };

  if (!isEmpty(filterValues.modelId)) {
    data.params.invoiceCreditId = filterValues.modelId;
  }

  if (!isEmpty(filterValues.payorId)) {
    data.params.subscriberId = filterValues.payorId;
  }
  if (featureFlags.SUBSCRIPTION_NAME && !isEmpty(filterValues.subscriptionName)) {
    data.params.subscriptionName = filterValues.subscriptionName;
  }
  if (!isEmpty(filterValues.startDate)) {
    const filterDateMoment = moment(filterValues.startDate);
    filterDateMoment
      .tz('UTC')
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0);

    data.params.startDate = filterDateMoment.format('YYYY-MM-DD');
  }

  if (!isEmpty(filterValues.endDate)) {
    const filterDateMoment = moment(filterValues.endDate);
    filterDateMoment
      .tz('UTC')
      .set('hour', 23)
      .set('minute', 59)
      .set('second', 59);

    data.params.endDate = filterDateMoment.format('YYYY-MM-DD');
  }

  return data;
};

export default {
  initialFilters: {
    modelId: '',
    subscriptionName: '',
    startDate: null,
    endDate: null,
    payorId: '',
    payorBillingName: ''
  },
  reportQuery: (facilityId, filterValues) => {
    const body = convertToApiBody(facilityId, filterValues);
    return queryGetReport(body);
  },
  fileName: 'transactions.csv',
};